const c = (t, o = "") => {
  const r = o.replace(/'/g, " ").replace(/[|<>&@!()*:]/g, "").trim().split(",").map((e) => e.trim()).filter(Boolean), s = [t.name, t.city, t.zipcode, t.address_full].map((e) => (e ?? "").toLowerCase());
  return r.length === 0 || r.some((e) => e.split(/\s+/).filter(Boolean).every((i) => s.some((l) => l.includes(i.toLowerCase()))));
};
export {
  c as isBusinessInQuery
};
